export interface SharedRoutes {
    multi: string;
}

export const sharedRoutes = {
    multi: '/multi',
};
